module.exports = __webpack_public_path__ + "static/media/me3_carousel_LeftArrow.a9a22fcf.svg";